
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Paul L., 86 ans, mort le 2 avril 2020</b>
    <br />
    <br />
    <i>Son épouse témoigne:</i>
    <br />
    <p>
  «Je peine encore à croire que mon mari n’est plus de ce monde. Nous avions
  tellement de projets ensemble. Il était en bonne santé. Il cultivait la joie
  de vivre. Et il est tombé malade. Mon mari est parti skier trois jours avec
  mon fils dans la station de Ischgl, en Autriche. Ils sont rentrés directement
  à l’hôtel après les pistes, sans passer par l’après-ski. Quand le village a
  finalement fait savoir, le 12 mars, qu'il y avait de sérieux problèmes avec le
  coronavirus, ils sont tout de suite rentrés à la maison. Cela n’a pas suffi.
  Ce même jour, mon fils a commencé à se sentir mal. Peu après, mon mari et moi
  avons ressenti les symptômes du virus. Nous avons été testés positifs. Lui a
  eu une forte fièvre, des douleurs musculaires, un épuisement physique. Nous
  savions que nous étions malades, mais jamais nous n’avons pensé à la mort.
  L’état de mon mari s’est rapidement dégradé. Il est allé à l’hôpital, qui l’a
  renvoyé à la maison après un bref contrôle. Un jour plus tard, mon fils l’a
  conduit dans une clinique privée. Cette fois-ci, le médecin lui a suggéré la
  respiration artificielle aux soins intensifs. Mon mari était convaincu que
  c’était le bon choix, qu’il pouvait vaincre l’infection et rentrer. Peu avant
  qu’il meure, la direction nous a autorisés, moi et mes enfants, à lui dire au
  revoir. Nous avons décidé de participer à l'action collective en justice
  contre la station de ski d’Ischgl. Quelqu'un doit assumer la responsabilité de
  ce qui s’est passé, même si cela n’atténuera pas notre souffrance.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;